import React from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiMapPin, FiPhone } from 'react-icons/fi';

const footerLinks = [
  { label: 'Home', to: '/' },
  { label: 'Products', to: '/shop' },
  { label: 'About Us', to: '/about' },
  { label: 'Payment Methods', to: '/payment-methods' },
  { label: 'Return & Refund Policy', to: '/return-refund-policy' },
  { label: 'Commercial Transaction Information', to: '/commercial-transaction-information' },
  { label: 'Terms & Conditions', to: '/terms-conditions' },
  { label: 'Privacy Policy', to: '/privacy-policy' },
  { label: 'Contact Us', to: '/contact-us' },
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <div className="footer-logo">
                <span className="logo-icon">
                  <img src="/favicon.ico" alt="LUAN LOGISTICS logo" width={24} height={24} />
                </span>
                <span className="logo-text">LUAN LOGISTICS</span>
              </div>
              <p className="footer-tagline">
                Reliable logistics and customer-first service with transparent policies, secure payments, and responsive support.
              </p>
              <div className="footer-company-box">
                <p><strong>GTB Holdings株式会社</strong><br />Legal Company / Business Operator</p>
                <p><strong>LUAN LOGISTICS</strong><br />Brand / Business Name</p>
              </div>
            </div>

            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul>
                {footerLinks.map((link) => (
                  <li key={link.label}><Link to={link.to}>{link.label}</Link></li>
                ))}
              </ul>
            </div>

            <div className="footer-col">
              <h4>Company Info</h4>
              <ul>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/shop">Products</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
              </ul>
            </div>

            <div className="footer-col">
              <h4>Contact</h4>
              <div className="footer-contact">
                <div className="contact-item">
                  <span><strong>Representative:</strong> Shinpei Ota (太田 真平)</span>
                </div>
                <div className="contact-item">
                  <FiMapPin size={14} />
                  <span>Kohara Building 307, 1-11-10 Uchikanda, Chiyoda-ku, Tokyo 101-0047, Japan</span>
                </div>
                <div className="contact-item">
                  <FiPhone size={14} />
                  <span><a href="tel:0362817035">03-6281-7035</a></span>
                </div>
                <div className="contact-item">
                  <FiMail size={14} />
                  <span><a href="mailto:luanlogistics@onebusiness.jp">luanlogistics@onebusiness.jp</a></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p>© 2026 LUAN LOGISTICS. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-conditions">Terms & Conditions</Link>
            <Link to="/contact-us">Contact Us</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
